import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { GermplasmAuditService } from '../germplasm-audit.service';
import { getEventDate, getEventUser } from '../germplasm-audit-utils';
import { GermplasmReferenceAudit } from './germplasm-reference-audit.model';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({
    selector: 'jhi-germplasm-reference-audit',
    templateUrl: './reference-audit.component.html',
    styleUrls: [
        '../germplasm-audit.scss'
    ]
})
export class ReferenceAuditComponent implements OnInit {

    readonly itemsPerPage: number = 10;

    gid: number;

    page: number;
    previousPage: number;
    totalItems: number;
    queryCount: number;
    isLoading: boolean;

    auditChanges: GermplasmReferenceAudit[];

    getEventDate = getEventDate;
    getEventUser = getEventUser;

    constructor(public activeModal: NgbActiveModal,
                private  germplasmAuditService: GermplasmAuditService,
                private translateService: TranslateService,
                private alertService: AlertService,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        this.gid = Number(this.activatedRoute.snapshot.queryParams.gid);
        this.page = 1;
    }

    ngOnInit(): void {
        this.loadAll();
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['./'], {
            queryParams:
                {
                    page: this.page,
                    size: this.itemsPerPage
                },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
        this.loadAll();
    }

    private loadAll() {
        this.isLoading = true;
        this. germplasmAuditService.getReferenceChanges(this.gid, {
            page: this.page - 1,
            size: this.itemsPerPage
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<GermplasmReferenceAudit[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    private onSuccess(data: GermplasmReferenceAudit[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.auditChanges = data;
    }

}
